module.exports = __webpack_public_path__ + "assets/img/skilled-icon.aed15b47.png";